import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_UNITS'),
  ...asyncTypes('CREATE_UNITS')
};

export default TYPES;
